<template>
  <div>
    <questions-nav
      @next="
        step(() => selected >= 0 && $emit('next', selected, selectedNextGroup))
      "
      @back="backStep(() => $emit('back'))"
      :showP="showP"
      :showN="selectedId > -1"
      :next="next"
      :previous="previous"
    />
  
    <tiles :items="tiles">
      <template v-slot:default="props">
        <TileWrap
          @click="$emit('tile-click', props.item.id, props.item.nextGroupID)"
        >
          <template v-slot:image >
            <media renderAs="div" :src="props.item.imageURL" />
          </template>
          <template v-slot:bottom>
            <custom-button
              :caption="props.item.text"
              :uppercase="true"
            ></custom-button>
          </template>
        </TileWrap>
      </template>
    </tiles>
  </div>
</template>
<script>
import Tiles from "../components/Tiles/Tiles.vue";
import TileWrap from "../components/Tiles/TileWrap.vue";
import Media from "../components/Media.vue";
import Button from "../components/Button.vue";
import QuestionsNav from "../components/QuestionsNav.vue";

import { isMobile } from "../mixins/is-mobile";

export default {
  name: "TilesQuestion",
  components: {
    Tiles,
    TileWrap,
    Media,
    CustomButton: Button,
    QuestionsNav
  },
  mixins: [isMobile],
  props: {
    tiles: {
      type: Array,
      required: true
    },
    selectedId: {
      type: Number,
      default: -1
    },
    showP: {
      type: Boolean,
      default: false
    },
    previous: String,
    next: String
  },
  data: function() {
    return {
      selected: -1,
      selectedNextGroup: -1
    };
  },
  watch: {
    selectedId: function(val, oldVal) {
      this.selected = val;
    }
  },
  methods: {
    selectQuestion: function(index, nextId) {
      this.$emit("next", index, nextId);
    },
    step: function(callback) {
      callback();
      this.selected = -1;
    },
    backStep: function(callback) {
      callback();
      this.selected = this.selectedId;
    }
  },
  mounted: function() {
    this.selected = this.selectedId;
  },
  activated: function() {
    this.selected = this.selectedId;
  }
};
</script>